<template>
    <v-container>
    <h2 class="titulo my-text">Reporte diario</h2>
    <v-divider id="divider"></v-divider>
    <p>Usted puede seleccionar un rango de fechas o un día puntual (ingresando en el campo fecha desde y fecha hasta el mismo día) y luego descargarlo y visualizarlo con el botón de descarga. Como resultado obtendrá un csv en formato texto donde se visualizarán datos de las solicitudes tales como "Porcentaje de facturación", "Token", "Número de autorización" y otros datos.</p>
    <p class="font-weight-light"> 
        <strong>Nota:</strong> Esta funcionalidad no deshabilita el envío del reporte diario por correo electrónico, es complementaria.
    </p>
    <v-row justify="center" align="center" class="mt-5">
        <v-col cols="12" md="6">    
            <p>Fecha desde:</p>
            <VueDatePicker 
                v-model="fechaDesde"
                :enableTimePicker="false"
                :auto-apply="true"
                :max-date="new Date()"
                :format-locale="es"
                :format="date => date ? date.getDate()+ '/' + (date.getMonth() + 1) + '/' + date.getFullYear() : ''"
                cancel-text="Cancelar"
                select-text="Aplicar"
                :teleport="true"
                :day-names="['Lun', 'Mar', 'Mier', 'Jue', 'Vie', 'Sab', 'Dom']"
            />
        </v-col>
        <v-col cols="12" md="6">
            <p>Fecha hasta:</p>
            <VueDatePicker
                v-model="fechaHasta"
                :enableTimePicker="false"
                :auto-apply="true"
                :max-date="new Date()"
                :min-date="fechaDesde"
                :format-locale="es"
                :format="date => date ? date.getDate()+ '/' + (date.getMonth() + 1) + '/' + date.getFullYear() : ''"
                cancel-text="Cancelar"
                select-text="Aplicar"
                :teleport="true"
                :day-names="['Lun', 'Mar', 'Mier', 'Jue', 'Vie', 'Sab', 'Dom']"
            />
        </v-col>
    </v-row>
    <v-row justify="center" align="center" class="mt-5">
        <v-btn id="boton-verde" @click="descargarReporte" :disabled="this.fechaDesde == null || this.fechaHasta == null">Generar y descargar</v-btn>
    </v-row>
    </v-container>
</template>

<style src="../assets/general.css"></style>

<script>
    import VueDatePicker from '@vuepic/vue-datepicker';
    import es from 'date-fns/locale/es';
    import PrestacionService from "../api/PrestacionService";

    const prestacionService = new PrestacionService();

    export default {
        name: 'ReporteTandil',
        components: {
            VueDatePicker
        },
        data() {
            return {
                fechaDesde: null,
                fechaHasta: null
            }
        },
        mounted() {
            this.fechaDesde = new Date();
            this.fechaDesde.setHours(0, 0, 0, 0);

            this.fechaHasta = new Date()
            this.fechaHasta.setHours(0, 0, 0, 0);
        },
        methods: {
            async descargarReporte(){
                const cuit = this.$store.getters.getFacturador.cuit;
                this.fechaDesde.setHours(0, 0, 0, 0);
                this.fechaHasta.setHours(0, 0, 0, 0);
                const response = await prestacionService.reporteDiarioTandil(cuit, this.fechaDesde, this.fechaHasta);
                if(response && response.status == 200){
                    const archivo = response.data;

                    const byteCharacters = atob(archivo.contenidoBase64);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const text = new TextDecoder("utf-8").decode(byteArray);
                    const blob = new Blob([text], { type: 'text/plain;charset=UTF-8' });

                    const blobUrl = URL.createObjectURL(blob);
                    const a = document.createElement('a');

                    a.href = blobUrl;
                    a.download = archivo.nombre || 'reporte_diario.pdf';

                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    window.open(blobUrl, '_blank');

                    URL.revokeObjectURL(blobUrl);
                }
            }
        }
    }
</script>